import api from './api';

const unwrap = (response) => response?.data?.data || response?.data || [];

/**
 * Get paginated & filtered notifications for the logged-in user.
 * @param {Object} params - Query parameters (page, limit, type, is_read)
 * @returns {Promise<Object>} Object containing notifications array, pagination metadata, and unread count
 */
export async function getNotifications(params = {}) {
  const response = await api.get('/notifications', { params });
  return unwrap(response);
}

/**
 * Get the current user's unread notification count.
 * @returns {Promise<Object>} Object containing unread_count
 */
export async function getUnreadCount() {
  const response = await api.get('/notifications/unread-count');
  return unwrap(response);
}

/**
 * Mark a specific notification as read.
 * @param {number|string} id - Notification ID
 * @returns {Promise<Object>} Backend success response
 */
export async function markAsRead(id) {
  const response = await api.put(`/notifications/${id}/read`);
  return unwrap(response);
}

/**
 * Mark all notifications as read for the logged-in user.
 * @returns {Promise<Object>} Backend success response
 */
export async function markAllAsRead() {
  const response = await api.put('/notifications/read-all');
  return unwrap(response);
}

/**
 * Soft delete a notification.
 * @param {number|string} id - Notification ID
 * @returns {Promise<Object>} Backend success response
 */
export async function deleteNotification(id) {
  const response = await api.delete(`/notifications/${id}`);
  return unwrap(response);
}

export default {
  getNotifications,
  getUnreadCount,
  markAsRead,
  markAllAsRead,
  deleteNotification
};
